module.exports = __webpack_public_path__ + "static/media/Announcement_Logov3.9064af7a.jpg";